import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form } from 'react-bootstrap';
import { Input, Checkbox, Select } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';

const EditPermission = ({ error, handleSubmit, pristine, submitting, isReadonly, permissionsType, initialValues, submitSucceeded, t }) => {
	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			<Field name='name' component={Input} disabled={true} horizontal type='text' label={t('Permission_Name')} />
			<Field name='description' component={Input} disabled={true} horizontal label={t('Permission_Description')} />
			{initialValues.type.name == 'Page' && <Select name='accessValue' disabled={isReadonly} required horizontal label={t('Permission_Permission')} data={permissionsType} validate={[validators.required]} />}
			{initialValues.type.name == 'Action' && <Field name='isExecuteGranted' component={Checkbox} disabled={isReadonly} horizontal label={t('Permission_IsExecute')} normalize={(v) => { return !!v }} />}
		</Form>
	);
};

export default reduxForm({ form: 'editPermission' })(withTranslation()(EditPermission));
